var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"float":"right","font-size":"smaller"}},[_c('span',{staticStyle:{"color":"gray"}},[_vm._v("Timezone: "+_vm._s(_vm.current_timezone))]),_vm._v(" "),(_vm.warning)?_c('span',[_c('el-button',{on:{"click":_vm.change_time}},[_vm._v("Change my timezone to "+_vm._s(_vm.browser_timezone))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }